/**
 * Calculates the number of full calendar days between two Date objects,
 * regardless of which one is earlier.
 *
 * @param date1 - The first Date object.
 * @param date2 - The second Date object.
 * @returns The absolute number of full days between the two dates.
 */

export const getNumberOfDays = (date1: Date, date2: Date): number => {
  if (!date1 || !date2) return 0;

  const start = new Date(
    date1.getFullYear(),
    date1.getMonth(),
    date1.getDate(),
  );
  const end = new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());

  const millisecondsPerDay = 1000 * 60 * 60 * 24;
  const timeDiff = Math.abs(end.getTime() - start.getTime());

  return Math.round(timeDiff / millisecondsPerDay);
};
